var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDouble = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#double_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5750EB",
  d: "M51.63 0s.112.111.273.136c6.426.916 11.614 6.278 12.085 12.939V50.95c-.582 7.02-6.03 12.468-13.05 13.062H13.063C6.413 63.517 1.04 58.33.136 51.916c-.025-.149-.099-.273-.136-.273V12.258C1.411 5.485 5.572 1.3 12.382 0h39.261zM35.72 51.742c2.068-.619 3.678-1.684 5.238-3.318l.062 3.306h6.104V11.676h-6.463V25.84c-3.987-4.333-10.76-4.692-15.737-2.266-6.587 3.331-9.447 10.871-7.602 17.892 2.154 8.16 10.35 12.654 18.411 10.264z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5851EB",
  d: "M32.316 46.394c-3.715.099-6.897-2.019-8.16-5.448-1.015-2.737-.879-5.82.459-8.42 1.337-2.6 3.9-4.234 6.834-4.445 3.38-.247 6.5 1.375 8.085 4.42 1.412 2.712 1.498 5.993.322 8.816-1.288 3.096-4.135 4.99-7.54 5.077"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "double_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h64v64H0z"
})))));
export default SvgDouble;